import { AssignTree, PAssignTreeType } from 'src/types'

import { FormModalTreeNodeProps } from './initial-values'

export default function sanitize(values: FormModalTreeNodeProps): AssignTree {
  const sanitized = JSON.parse(JSON.stringify(values))

  sanitized.assign_tree_id = null
  delete sanitized.childrens
  delete sanitized.color
  delete sanitized.created_by_uid
  delete sanitized.created_on
  delete sanitized.parent_name
  delete sanitized.updated_by_uid
  delete sanitized.updated_on
  delete sanitized.version

  if (values.p_assign_tree_type === PAssignTreeType.COST_CENTER) {
    sanitized.cost_center_id = +sanitized.cost_center_id
    delete sanitized.cost_center
    delete sanitized.organization_id
  }

  if (values.p_assign_tree_type === PAssignTreeType.REASON) {
    sanitized.reason_id = +sanitized.reason_id
    delete sanitized.reason
  }

  if (values.p_assign_tree_type === PAssignTreeType.USER) {
    sanitized.user_id = +sanitized.user_id
  }

  return sanitized
}
